import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { NewPatientSchedulerService } from 'src/app/services/new-patient-scheduler.service';
import { NewPatientAppointment } from 'src/app/models/AvaContext';

@Component({
    selector: 'dialog-booking-details',
    templateUrl: './dialog-booking-details.component.html',
    styleUrls: ['./dialog-booking-details.component.css'],
    standalone: false
})

export class DialogBookingDetailsComponent implements OnInit, OnDestroy {
  customAnswers: {questionId: string; prompt: string; value: string}[] = [];
  customAnswersError = '';
  private answersRequest?: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: NewPatientAppointment, private scheduler: NewPatientSchedulerService) { }
  ngOnInit(): void {
    this.answersRequest = this.scheduler.customAnswers(this.data.newPatientAppointmentId).subscribe({
      next: answers => this.customAnswers = answers,
      error: () => this.customAnswersError = 'Unable to load additional answers. Please reopen Booking Details to try again.'
    });
  }
  ngOnDestroy(): void { this.answersRequest?.unsubscribe(); }

  isDefaultDate(date: string | Date): boolean {
    if (typeof (date) === 'string') {
      return date.match(/^(.+)T/)[1] === '0001-01-01';
    } else {
      const d = <Date>date;
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0);
      return d.getTime() === new Date(1, 1, 1).getTime();
    }
  }
}

